import type { IconSvgObject } from './types';

const ShoppingBasketCheckIn02Icon: IconSvgObject = [
  ["path", { d: "M7 8V6.5C7 4.01472 9.01472 2 11.5 2C13.9853 2 16 4.01472 16 6.5V8", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M14 22H6.73459C5.73929 22 4.89545 21.2681 4.75469 20.2828L3 8H20L19.5 12", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M17 17.5L19 15.5L21 17.5M19 22V16.1108", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }],
  ["path", { d: "M5 18H13.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "3" }]
];

export default ShoppingBasketCheckIn02Icon;
